<template>
<div>

<div class="modal-content border border-success">
<div  style="background-color:#9acd32;color:black" class="modal-header border border-success text-nowrap ">
  <h4 class="modal-title ">
    <i style="color:blue" class="fas fa-cash-register mr-3" aria-hidden="true"></i>     
    <strong>STAMPA SCONTRINO DI CORTESIA</strong>
    <hr>
    <span><strong>{{ data.url }}</strong></span>
  </h4>  
</div>

<div class="modal-body">
  <div>

  </div>
  <button @click="$emit('close')" type="button" class="btn btn-secondary float-left mt-2">
      <i class="fas fa-reply mr-2" aria-hidden="true"></i>
        ANNULLA
  </button>

  <button  @click="postXML()" :disabled="bt_spinner==true" type="button" class="btn btn-primary float-right mt-2">
          <i class="fas fa-print mr-2" aria-hidden="true"></i>   
            STAMPA 
          <span v-if="bt_spinner"  class="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>
  </button>  

</div>
</div>
</div>


</template>

<script>


import axios             from 'axios'
import alertBox          from '@/components/common/AlertBox.vue'
import { mapGetters }    from 'vuex'

  export default {

  props : ['data'],

     components: {alertBox},
    data () {
      return {
        
          msg         : {title : '',body:'',type :0},          
          url         : '',
          bt_spinner  : false

                                   
      }
    },

    
    computed: {
     ...mapGetters(['company']),
      
    },
    
    created () 
      {
        console.log('EPSON NOT FISCAL RECEIPT  DATA',this.data)
        //this.getSaleData()
      },
    
    methods: 
    {
    
    
    getXML() 
     {
        
        let xml = ''  
        xml = '<printerNonFiscal><beginNonFiscal/>'
        xml += '<printNormal operator="1" font="3" data="             SCONTRINO DI CORTESIA" />'
        
        /* SCALIA AGRIGENTO */
        if(this.company.Id == 48)  
        {
          xml += '<printNormal operator="1" font="1" data="." />'
          xml += '<printNormal operator="1" font="1" data="     I CAMBI SI EFFETTUANO DA LUNEDI" />'
          xml += '<printNormal operator="1" font="1" data="     A VENERDI ESIBENDO LO SCONTRINO" />'
          xml += '<printNormal operator="1" font="1" data="     ENTRO 7 GIORNI DALL\'ACQUISTO." />'
          xml += '<printNormal operator="1" font="1" data="." />'
        }
        

        xml += '<printBarCode  position="901" width="3" height="100" HRIPosition="1" HRIFont="A" codeType="69" code="' + "S" +  this.data.saleId + '"/>'        






        xml += '<endNonFiscal/>'
        
        console.log('EPSON GIFT RECEIPT',xml)  

        return xml              
      },
      getSOAP(xml)
      {
            const soap = '<?xml version="1.0" encoding="utf-8"?>\n' +
            '<s:Envelope xmlns:s="http://schemas.xmlsoap.org/soap/envelope/">\n' +
              '<s:Body>\n' + xml +
            '</s:Body>\n' +
            '</s:Envelope>\n'
            return soap
      },
      postXML()
      {   this.bt_spinner = true
          const soap = this.getSOAP(this.getXML())
          axios({
               
               url    : this.data.url + '/cgi-bin/fpmate.cgi',
               method : 'post',
               data   : soap

             }).then(res => {
                this.bt_spinner = false
                console.log('RT Response',res)
                
                  this.$emit('close')
                            
             }).catch(err => {
               this.bt_spinner = false                             
               console.log('Errore RT',err)  
             })
       
      },    
           
   
     } 
      

    
  }
</script>
<style scoped>

  h4 {
  font-family  : 'Roboto Condensed';
  font-size    : 20px;
}
.modal-content
{
  width:  500px;
}
</style>
